<template>
  <div
    v-if="enabled"
    class="cargo-ai-host"
  >
    <div
      class="cargo-ai-ball"
      :title="isOpen ? '收起 AI 助手' : 'AI 助手'"
      @click="togglePanel"
    >
      <svg
        class="cargo-ai-ball-icon"
        viewBox="0 0 24 24"
        width="24"
        height="24"
      >
        <path
          d="M12 2l2.4 7.6L22 12l-7.6 2.4L12 22l-2.4-7.6L2 12l7.6-2.4z"
          fill="#fff"
        />
      </svg>
    </div>
    <div
      class="cargo-ai-panel"
      :class="{ 'is-open': isOpen }"
    >
      <div
        v-if="loading"
        class="cargo-ai-loading"
      >
        <div class="cargo-ai-loading-spinner" />
        <div class="cargo-ai-loading-text">正在加载 AI 助手…</div>
      </div>
      <iframe
        v-if="aiUrl"
        ref="aiIframe"
        title="cargo-ai"
        class="cargo-ai-iframe"
        allow="clipboard-write"
        :src="aiUrl"
        @load="onIframeLoad"
      />
    </div>
  </div>
</template>

<script>
import { parseNavigateMessage } from './cargoAiProtocol'
import { handleNavigate } from './cargoAiRouter'

export default {
  name: 'CargoAiHost',
  data() {
    return {
      isOpen: false,
      aiUrl: '',
      loading: false
    }
  },
  computed: {
    // env 门控：VUE_APP_CARGO_AI_URL 为空（公司各环境缺省）时整体不渲染
    enabled() {
      return Boolean(String(process.env.VUE_APP_CARGO_AI_URL || '').trim())
    }
  },
  mounted() {
    if (!this.enabled) return
    window.addEventListener('message', this.onMessage, false)
  },
  beforeDestroy() {
    window.removeEventListener('message', this.onMessage)
  },
  methods: {
    togglePanel() {
      if (this.isOpen) {
        this.isOpen = false
        return
      }
      // 惰性挂载：首次打开才建 iframe，之后常驻（小窗开合不重载会话）
      if (!this.aiUrl) {
        this.aiUrl = String(process.env.VUE_APP_CARGO_AI_URL).trim()
        this.loading = true
      }
      this.isOpen = true
    },
    onIframeLoad() {
      this.loading = false
    },
    onMessage(event) {
      // 同源部署（ADR 0010）：iframe 的源就是自身源；再校验消息确实来自这个 iframe，
      // 页面上其他 postMessage 流量（沃宝、webpack devserver 等）一律不响应
      if (event.origin !== window.location.origin) return
      const iframe = this.$refs.aiIframe
      if (!iframe || event.source !== iframe.contentWindow) return
      const intent = parseNavigateMessage(event.data)
      if (!intent) return
      handleNavigate(this, intent)
    }
  }
}
</script>

<style scoped>
.cargo-ai-ball {
  position: fixed;
  right: 16px;
  bottom: 16px;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: linear-gradient(135deg, #409eff, #7b5cd6);
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 900;
  transition: transform 0.2s;
}

.cargo-ai-ball:hover {
  transform: scale(1.08);
}

.cargo-ai-ball-icon {
  pointer-events: none;
}

.cargo-ai-panel {
  position: fixed;
  right: 16px;
  bottom: 76px; /* 球 48px + 12px 间距 */
  width: 420px;
  max-width: calc(100vw - 32px);
  height: min(640px, calc(100vh - 120px));
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);
  overflow: hidden;
  z-index: 2000;
  transform: translateY(12px) scale(0.96);
  transform-origin: right bottom;
  opacity: 0;
  visibility: hidden;
  transition: transform 0.2s ease, opacity 0.2s ease, visibility 0.2s;
}

.cargo-ai-panel.is-open {
  transform: none;
  opacity: 1;
  visibility: visible;
}

.cargo-ai-iframe {
  width: 100%;
  height: 100%;
  border: none;
}

.cargo-ai-loading {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #f5f7fa;
}

.cargo-ai-loading-spinner {
  width: 36px;
  height: 36px;
  border: 3px solid #e4e7ed;
  border-top-color: #409eff;
  border-radius: 50%;
  animation: cargo-ai-spin 1s linear infinite;
  margin-bottom: 12px;
}

.cargo-ai-loading-text {
  color: #909399;
  font-size: 13px;
}

@keyframes cargo-ai-spin {
  100% {
    transform: rotate(360deg);
  }
}
</style>
